import styled from 'styled-components';

export const StyledParagraph = styled('p')`
  text-align: center;
  color: red;
`;
